// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.call-center-page {
  padding: 16px;
}

.call-center-title {
  margin: 0 0 6px;
}

.call-center-subtitle {
  margin: 0 0 16px;
  color: #4b5563;
}

.call-center-card {
  background: #ffffff;
  border: 1px solid #dce3ea;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 14px;
}

.call-center-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
  gap: 12px;
}

.call-center-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.call-center-field input,
.call-center-field textarea {
  border: 1px solid #cfd8e3;
  border-radius: 6px;
  padding: 8px 10px;
  font-size: 14px;
}

.call-center-actions {
  margin-top: 12px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.call-center-btn {
  background: #0f766e;
  color: #fff;
  border: 0;
  border-radius: 6px;
  padding: 8px 12px;
  cursor: pointer;
}

.call-center-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.call-center-btn-secondary {
  background: #2563eb;
}

.call-center-table-wrap {
  overflow-x: auto;
}

.call-center-table {
  width: 100%;
  border-collapse: collapse;
}

.call-center-table th,
.call-center-table td {
  text-align: left;
  border-bottom: 1px solid #e5e7eb;
  padding: 10px;
  font-size: 14px;
}

.call-center-badge {
  display: inline-block;
  background: #ecfeff;
  color: #155e75;
  border: 1px solid #a5f3fc;
  border-radius: 999px;
  padding: 3px 10px;
  font-size: 12px;
}

.call-center-message {
  margin: 8px 0;
  padding: 8px 10px;
  border-radius: 6px;
  border: 1px solid #d1d5db;
  background: #f9fafb;
}

.call-center-message-error {
  border-color: #fecaca;
  background: #fef2f2;
  color: #b91c1c;
}

.call-center-message-success {
  border-color: #bbf7d0;
  background: #f0fdf4;
  color: #166534;
}

.call-center-links {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
}

.call-center-link-card {
  display: block;
  text-decoration: none;
  color: inherit;
  border: 1px solid #dce3ea;
  border-radius: 8px;
  padding: 12px;
  background: #ffffff;
}

.call-center-link-card h3 {
  margin: 0 0 6px;
}

.call-center-link-card p {
  margin: 0;
  color: #4b5563;
}
`, "",{"version":3,"sources":["webpack://./src/call-center/CallCenter.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;EAChB,gCAAgC;EAChC,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB","sourcesContent":[".call-center-page {\n  padding: 16px;\n}\n\n.call-center-title {\n  margin: 0 0 6px;\n}\n\n.call-center-subtitle {\n  margin: 0 0 16px;\n  color: #4b5563;\n}\n\n.call-center-card {\n  background: #ffffff;\n  border: 1px solid #dce3ea;\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 14px;\n}\n\n.call-center-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));\n  gap: 12px;\n}\n\n.call-center-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.call-center-field input,\n.call-center-field textarea {\n  border: 1px solid #cfd8e3;\n  border-radius: 6px;\n  padding: 8px 10px;\n  font-size: 14px;\n}\n\n.call-center-actions {\n  margin-top: 12px;\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.call-center-btn {\n  background: #0f766e;\n  color: #fff;\n  border: 0;\n  border-radius: 6px;\n  padding: 8px 12px;\n  cursor: pointer;\n}\n\n.call-center-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.call-center-btn-secondary {\n  background: #2563eb;\n}\n\n.call-center-table-wrap {\n  overflow-x: auto;\n}\n\n.call-center-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.call-center-table th,\n.call-center-table td {\n  text-align: left;\n  border-bottom: 1px solid #e5e7eb;\n  padding: 10px;\n  font-size: 14px;\n}\n\n.call-center-badge {\n  display: inline-block;\n  background: #ecfeff;\n  color: #155e75;\n  border: 1px solid #a5f3fc;\n  border-radius: 999px;\n  padding: 3px 10px;\n  font-size: 12px;\n}\n\n.call-center-message {\n  margin: 8px 0;\n  padding: 8px 10px;\n  border-radius: 6px;\n  border: 1px solid #d1d5db;\n  background: #f9fafb;\n}\n\n.call-center-message-error {\n  border-color: #fecaca;\n  background: #fef2f2;\n  color: #b91c1c;\n}\n\n.call-center-message-success {\n  border-color: #bbf7d0;\n  background: #f0fdf4;\n  color: #166534;\n}\n\n.call-center-links {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 12px;\n}\n\n.call-center-link-card {\n  display: block;\n  text-decoration: none;\n  color: inherit;\n  border: 1px solid #dce3ea;\n  border-radius: 8px;\n  padding: 12px;\n  background: #ffffff;\n}\n\n.call-center-link-card h3 {\n  margin: 0 0 6px;\n}\n\n.call-center-link-card p {\n  margin: 0;\n  color: #4b5563;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
